const hooks = {
    'Clients': {
        'ClientForm.Roles': () => {
            return { identifier: 'admin', name: "مدیر" }
        }
    }
};

export default hooks;